import { Cross2Icon } from '@radix-ui/react-icons'
import { BlocklistLog } from '../../types/BlocklistTypes'
import { formatUtcTimestamp } from '../../utils/dates'

interface IDomainBlocklistLogsPopoutContentProps {
  popoutData: BlocklistLog
  setShowPopout: (show: boolean) => void
}

export const DomainBlocklistLogsPopoutContent = (props: IDomainBlocklistLogsPopoutContentProps) => {
  const { popoutData, setShowPopout } = props

  return (
    <>
      {/* domain */}
      <div className="w-full">
        <div className="w-full h-20 border-mainBorder border-b flex px-8">
          <div className="w-3/4 h-20 flex flex-col justify-center">
            <div className="text-mainText text-lg font-semibold leading-normal whitespace-normal max-two-lines">
              {popoutData.domain}
            </div>
          </div>
          <div className="w-1/4 h-20 flex justify-end items-center float-right">
            <div
              className="w-6 h-6 cursor-pointer"
              onClick={() => {
                setShowPopout(false)
              }}
            >
              <Cross2Icon className="w-6 h-6" />
            </div>
          </div>
        </div>
        {/* blocked count */}
        <div className="w-full h-12 border-mainBorder border-b flex px-8">
          <div className="w-1/3 h-12 flex flex-col justify-center">
            <div className="text-mainText text-sm font-normal leading-normal">Blocked Count</div>
          </div>
          <div className="w-2/3 h-12 flex justify-end items-center float-right">
            <div className="text-mainText text-sm font-semibold leading-normal">{popoutData.timesBlocked}</div>
          </div>
        </div>
        {/* Last occurred date */}
        <div className="w-full h-12 border-mainBorder border-b flex px-8">
          <div className="w-1/3 h-12 flex flex-col justify-center">
            <div className="text-mainText text-sm font-normal leading-normal">Last Blocked</div>
          </div>
          <div className="w-2/3 h-12 flex justify-end items-center float-right">
            <div className="text-mainText text-sm font-semibold leading-normal">
              {formatUtcTimestamp(popoutData.lastOccurredAt, false, true)}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
